'use strict';

import { Entity } from '../Entity';
import { Company } from '../Company';

export class AgencyReportUpload extends Entity {
  protected id;

  protected agency;

  protected uploadType;

  protected fileName;

  protected fileSystemName;

  protected fileData;

  protected status;

  protected dateTimeCreated;

  protected planYear;

  protected company: Company;

  protected headerValues;

  protected contractsProcessed;

  protected rtsProcessed;

  protected stateProcessed;

  protected productProcessed;

  protected writingNumberProcessed;

  protected missingContractProcessed;

  protected missingContractsExport;

  private extractionOffset;

  private extractionStatus;

  private fileRowsCount;

  private contractsOffset;

  private contractsStatus;

  private rtsOffset;

  private rtsStatus;

  private statesOffset;

  private statesStatus;

  private productsOffset;

  private productsStatus;

  private writingNumbersOffset;

  private writingNumbersStatus;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.agency = data.agency;

    this.uploadType = data.uploadType;

    this.fileName = data.fileName;

    this.fileSystemName = data.fileSystemName;

    this.fileData = data.fileData;

    this.status = data.status;

    this.planYear = data.planYear;

    this.headerValues = data.headerValues;

    this.contractsProcessed = data.contractsProcessed;

    this.rtsProcessed = data.rtsProcessed;

    this.stateProcessed = data.stateProcessed;

    this.productProcessed = data.productProcessed;

    this.writingNumberProcessed = data.writingNumberProcessed;

    this.missingContractProcessed = data.missingContractProcessed;

    this.missingContractsExport = data.missingContractProcessed;

    this.extractionOffset = data.extractionOffset;

    this.extractionStatus = data.extractionStatus;

    this.fileRowsCount = data.fileRowsCount;

    this.contractsOffset = data.contractsOffset;

    this.contractsStatus = data.contractsStatus;

    this.rtsOffset = data.rtsOffset;

    this.rtsStatus = data.rtsStatus;

    this.productsOffset = data.productsOffset;

    this.productsStatus = data.productsStatus;

    this.statesOffset = data.statesOffset;

    this.statesStatus = data.statesStatus;

    this.writingNumbersOffset = data.writingNumbersOffset;

    this.writingNumbersStatus = data.writingNumbersStatus;

    if (data.dateTimeCreated) {
      const dateTimeCreated = data.dateTimeCreated.date.split(' ')[0].split('-');
      this.dateTimeCreated =
        dateTimeCreated[1] + '/' + dateTimeCreated[2] + '/' + dateTimeCreated[0];
    }

    if (data.company) {
      const company = new Company();

      company.hydrate(data.company);

      this.company = company;
    }
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getAgency() {
    return this.agency;
  }

  public setAgency(agency) {
    this.agency = agency;

    return this;
  }

  public getUploadType() {
    return this.uploadType;
  }

  public setUploadType(uploadType) {
    this.uploadType = uploadType;

    return this;
  }

  public getFileName() {
    return this.fileName;
  }

  public setFileName(fileName) {
    this.fileName = fileName;

    return this;
  }

  public getFileSystemName() {
    return this.fileSystemName;
  }

  public setFileSystemName(fileSystemName) {
    this.fileSystemName = fileSystemName;

    return this;
  }

  public getFileData() {
    return this.fileData;
  }

  public setFileData(fileData) {
    this.fileData = fileData;

    return this;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public setDateTimeCreated(dateTimeCreated) {
    this.dateTimeCreated = dateTimeCreated;

    return this;
  }

  public getStatus() {
    return this.status;
  }

  public setStatus(status) {
    this.status = status;

    return this;
  }

  public getCompany() {
    return this.company;
  }

  public setCompany(company) {
    this.company = company;

    return this;
  }

  public getPlanYear() {
    return this.planYear;
  }

  public setPlanYear(planYear) {
    this.planYear = planYear;

    return this;
  }

  public getHeaderValues() {
    return this.headerValues;
  }

  public setHeaderValues(headerValues) {
    this.headerValues = headerValues;

    return this;
  }

  public isContractsProcessed() {
    return this.contractsProcessed;
  }

  public setContractsProcessed(contractsProcessed) {
    this.contractsProcessed = contractsProcessed;

    return this;
  }

  public isRtsProcessed() {
    return this.rtsProcessed;
  }

  public setRtsProcessed(rtsProcessed) {
    this.rtsProcessed = rtsProcessed;

    return this;
  }

  public isStateProcessed() {
    return this.stateProcessed;
  }

  public setStateProcessed(stateProcessed) {
    this.stateProcessed = stateProcessed;

    return this;
  }

  public isProductProcessed() {
    return this.productProcessed;
  }

  public setProductProcessed(productProcessed) {
    this.productProcessed = productProcessed;

    return this;
  }

  public isWritingNumberProcessed() {
    return this.writingNumberProcessed;
  }

  public setWritingNumberProcessed(writingNumberProcessed) {
    this.writingNumberProcessed = writingNumberProcessed;

    return this;
  }

  public isMissingContractProcessed() {
    return this.missingContractProcessed;
  }

  public setMissingContractProcessed(missingContractProcessed) {
    this.missingContractProcessed = missingContractProcessed;

    return this;
  }

  public getMissingContractsExport() {
    return this.missingContractsExport;
  }

  public setMissingContractsExport(missingContractsExport) {
    this.missingContractsExport = missingContractsExport;

    return this;
  }

  public getExtractionOffset() {
    return this.extractionOffset;
  }

  public setExtractionOffset(extractionOffset) {
    this.extractionOffset = extractionOffset;

    return this;
  }

  public getExtractionStatus() {
    return this.extractionStatus;
  }

  public setExtractionStatus(extractionStatus) {
    this.extractionStatus = extractionStatus;

    return this;
  }

  public getFileRowsCount() {
    return this.fileRowsCount;
  }

  public setFileRowsCount(fileRowsCount) {
    this.fileRowsCount = fileRowsCount;

    return this;
  }

  public getContractsOffset() {
    return this.contractsOffset;
  }

  public setContractsOffset(contractsOffset) {
    this.contractsOffset = contractsOffset;

    return this;
  }

  public getContractsStatus() {
    return this.contractsStatus;
  }

  public setContractsStatus(contractsStatus) {
    this.contractsStatus = contractsStatus;

    return this;
  }

  public getRtsOffset() {
    return this.rtsOffset;
  }

  public setRtsOffset(rtsOffset) {
    this.rtsOffset = rtsOffset;

    return this;
  }

  public getRtsStatus() {
    return this.rtsStatus;
  }

  public setRtsStatus(rtsStatus) {
    this.rtsStatus = rtsStatus;

    return this;
  }

  public getStatesOffset() {
    return this.statesOffset;
  }

  public setStatesOffset(statesOffset) {
    this.statesOffset = statesOffset;

    return this;
  }

  public getStatesStatus() {
    return this.statesStatus;
  }

  public setStatesStatus(statesStatus) {
    this.statesStatus = statesStatus;

    return this;
  }

  public getProductsOffset() {
    return this.productsOffset;
  }

  public setProductsOffset(productsOffset) {
    this.productsOffset = productsOffset;

    return this;
  }

  public getProductsStatus() {
    return this.productsStatus;
  }

  public setProductsStatus(productsStatus) {
    this.productsStatus = productsStatus;

    return this;
  }

  public getWritingNumbersOffset() {
    return this.writingNumbersOffset;
  }

  public setWritingNumbersOffset(writingNumbersOffset) {
    this.writingNumbersOffset = writingNumbersOffset;

    return this;
  }

  public getWritingNumbersStatus() {
    return this.writingNumbersStatus;
  }

  public setWritingNumbersStatus(writingNumbersStatus) {
    this.writingNumbersStatus = writingNumbersStatus;

    return this;
  }
}
